import $ from 'jquery';

$('.cmd-menu-button').click(function() {
    $(this).blur();
});

$(document).on('click',function(e){

    if (!$(e.target).is('.cmd-overflow-dropdown-handler')) {
        $('.cmd-overflow-dropdown').css('display', 'none');
    }

    if (!$(e.target).is('input') && !$(e.target).is('form')) {
        $('.collapse').collapse('hide');
    }
});

var getViewportWidth = function () {
    return $('#viewportSize').find('div:visible').first().attr('id');
}

$('.dropdown-toggle').click(function () {
    var viewportWidth = getViewportWidth();

    if (viewportWidth == 'xs' || viewportWidth == 'sm') return;

    var location = $(this).attr('href');
    window.location.href = location;
    return false;
});


$("#txtSearch").on( "keypress", function(event) {
    if (event.which == 13 && !event.shiftKey) {
        event.preventDefault();
        window.location.href = SEARCH_ROUTE + $(this).val();
    }
});


$(".btn-search").on( "click", function() {
    var searchText = $("#txtSearch").val();
    if (searchText !== '') {
        window.location.href = SEARCH_ROUTE + searchText;
    }
});

$("#txtSubscription").on( "keypress", function(event) {
    if (event.which == 13 && !event.shiftKey) {
        event.preventDefault();
        if (!$("#txtSubscription").val() || !validateEmail($("#txtSubscription").val())) {
            $('#errorEmail').css('display', 'block');
            return true;
        } else {
            $('#errorEmail').css('display', 'none');
        }
        sendSubscription($(this).val());
    }
});

$('#btnSubscription').click(function () {
    if (!$("#txtSubscription").val() || !validateEmail($("#txtSubscription").val())) {
        $('#errorEmail').css('display', 'block');
        return true;
    } else {
        $('#errorEmail').css('display', 'none');
    }
    sendSubscription($("#txtSubscription").val());
    return false;
});

function validateEmail(mail) 
{
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return (true)
    }
    return (false)
}


function sendSubscription(email) {
    if(isEmail(email)){
        $.ajax({
            type: "POST",
            url: '/blog-xe-hoi/api/subscription/',
            data: {email:email},
            success: function (){
                $('#myModal').modal('show')
            }
        });
    }
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}



// WEBPACK FOOTER //
// ./resources/assets/js/common.js